import Image from 'next/legacy/image'
import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-three-parts.module.scss'
import { Markdown } from '../../../../components/markdown'
import type { BentoPieceRectangleThreePartsPartFragment } from '../../../../graphql/queries/GetBentoOne.graphql'
import { usePersonalizations } from '../../../../lib/hooks/usePersonalizations'
import { renderTemplate } from '../../../../lib/utils/text'

export const Part: FunctionComponent<Props> = ({ heading, copy, image }) => {
    const personalizations = usePersonalizations()

    return (
        <div className={styles.section}>
            <div className={styles.heading}>
                <Markdown
                    tag='h3'
                    typeStyle='heading-md'
                    markdown={renderTemplate(heading, personalizations)}
                />
            </div>
            <div className={styles.copy}>
                <Markdown
                    tag='p'
                    typeStyle='body-md'
                    markdown={renderTemplate(copy, personalizations)}
                />
            </div>
            <div className={styles.image}>
                {image && (
                    <Image
                        className={styles.image}
                        src={image.url ?? ''}
                        width={image.width}
                        height={image.height}
                        alt={image.alt ?? ''}
                    />
                )}
            </div>
        </div>
    )
}

export default Part

type Props = Omit<BentoPieceRectangleThreePartsPartFragment, 'sys' | 'type'> & {
    copy?: string
}
